<template>
  <div>
    <!-- <Header v-if="!solicitarCertidao" :logged="logged" :totem="totem" /> -->
    <Header :logged="logged" :totem="totem" />
    <b-modal ref="modalInstabilidade" @ok="confirmar" title="Atenção" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
      <p>
        Prezados,
      </p>
      <p>
        Informamos que todos os serviços do Banco Bradesco estão indisponíveis e, por conta disso, nosso gateway de pagamento está indisponível. Reforçamos ser uma indisponibilidade geral no Banco Bradesco e estamos aguardando o restabelecimento dos serviços por parte do banco.
      </p>
      <p>
        <a href="https://www.techtudo.com.br/noticias/2024/07/bradesco-next-e-outros-bancos-estao-fora-do-ar-hoje-19-entenda-o-motivo-edapps.ghtml" target="_blank">
          https://www.techtudo.com.br/noticias/2024/07/bradesco-next-e-outros-bancos-estao-fora-do-ar-hoje-19-entenda-o-motivo-edapps.ghtml
        </a>
      </p>
      <p>
        Qualquer dúvida, estamos à disposição!
      </p>
    </b-modal>
    <b-modal ref="erroPush" @ok="confirmaErroPush" title="Atenção" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
      <p>{{this.erroPushMsg}}</p>
    </b-modal>
    <b-modal ref="modalBoleto" size="xl" scrollable title="Boleto" id="modal-dialog">
      <b-embed type="iframe" aspect="1by1" :src="ds_endereco_boleto"  allowfullscreen v-if="ds_endereco_boleto"></b-embed>
      <p v-else class="mensagemErro bold">{{msg_retorno}}</p>
    </b-modal>
    <b-modal ref="erro" title="Atenção">
      <p>{{ this.erroCertidao }}</p>
    </b-modal>
    <b-modal ref="modalLoading" size="xl" title="Carregando" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
      <p class="my-4">
        <template>
          <div class="d-flex justify-content-center mb-3">
            <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
          </div>
        </template>
      </p>
    </b-modal>
    <b-modal ref="modalErro" title="Atenção">{{ msgValida }}</b-modal>
    <a style="display:block" :id="'download_boleto'" :download="'download_boleto'" />
    <b-modal ref="modalPagamento" id="modalPagamento" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-header-close="true" size="lg">
      <template v-slot:modal-header="{ close }">
        <h5>Selecione a forma de pagamento</h5>
      </template>
      <template v-slot:default="{ hide }">
        <b-form-select id="input-4" v-model="formaPagamento" :options="formasPagamento" @change="alteraFPG"></b-form-select>
        <div v-if="formaPagamento.toString().includes('credit') == true" class="mt-4">
          <b-card bg-variant="light" title="Dados do cartão">
            <parcela-checkout
              :environment="ENVIRONMENT_EXPRESS"
              :clientKey="CLIENT_KEY_EXPRESS"
              :apiUrl="URL_EXPRESS"
              :sellerKey="SELLER_KEY_EXPRESS"
              successReturnUrl="https://success-url.com.br"
              errorReturnUrl="https://error-url.com.br"
            />
          </b-card>
        </div>
        <p class="mt-3">Caso o pagamento não seja realizado na data de vencimento, o pedido será automaticamente cancelado.</p>
        <br />
        <p>
          A opção de pagamento de certidão/cancelamento, seja por meio de PIX, cartão de crédito ou boleto não altera o prazo de entrega/efetivação, pois a transferência ao devido tabelionato, ocorre
          1 dia após ao efetivo pagamento.
        </p>
        <br />
        <p><b style="color: red;">*Após realizado o pagamento, os pedidos não poderão mais ser cancelados</b></p>
        <br>
        <p>O processamento dos pagamentos são realizados pela Parcela Express Servicos Digitais.</p>
      </template>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="lg" variant="danger" class="mr-auto" @click="respConfirm('n')">Cancelar</b-button>
        <b-button size="lg" variant="success" @click="respConfirm('s')" v-if="formaPagamento.toString().includes('credit') !== true">Aceitar</b-button>
      </template>
    </b-modal>
    <b-modal ref="ModalPagamentoCartao" title="Pagamento Recusado">
      <p>Pagamento recusado! Verifique os dados do cartão e tente novamente.</p>
    </b-modal>
    <b-modal ref="modalBoleto" :size="sizemodalboleto" scrollable title="Boleto" id="modalboleto">
      <div v-if="pdf">
        <div v-if="sizemodalboleto == 'lg'">
          <div class="col-12 text-center">
            <img src="~@/assets/imgs/logo.svg" class="w-50" />
            <br /><br /><br /><br />
            <h4>
              <b>Valor R$: {{ boletoSelecionado.vl_orcamento || Moeda }}</b>
            </h4>
            <br /><br />
          </div>
          <div class="offset-4 col-8 text-center qrcodePix">
            <b-embed type="iframe" aspect="1by1" :src="pdf" allowfullscreen v-if="pdf"></b-embed>
          </div>
          <div class="col-12 text-center">
            <h4><b>Faça a leitura do QR CODE e aguarde.</b></h4>
            <h4><b>Ou</b></h4>
            <b-card>
              <h5><b>LINK DE PAGAMENTO (PIX COPIA E COLA)</b></h5>
              <textarea class="textarea" ref="copiar" v-model="linkPIX" cols="80" rows="4"></textarea>
              <b-button variant="primary" @click="copiarLink()"> <font-awesome-icon icon="copy" /> &nbsp;&nbsp;&nbsp;&nbsp; Copiar link de pagamento </b-button>
            </b-card>
            <h4>
              <br /><br /><b>Consulta de pagamento em {{ secondcd }} segundos.</b>
            </h4>
          </div>
        </div>
        <div v-else>
          <b-embed type="iframe" aspect="1by1" :src="pdf" allowfullscreen v-if="pdf"></b-embed>
        </div>
      </div>
      <p v-else class="mensagemErro bold">{{ mensagemBolErro }}</p>
    </b-modal>

    <protestoanuenciacancelamento :itemsp="items" v-if="items.length > 0" :servicoComplementar="servico_complementar" />
    <!-- MODAL DETALHES DO CARTÓRIO -->
    <b-modal v-if="qtdTitulos > 0" ref="modal-detalhes" class="modal-detalhes-consulta" id="modal-xl" size="xl" centered :title="detalhes_cartorio.nomeCartorio">
      <p class="mb-3 text-consulta-modal"><b>Endereço: </b>{{ detalhes_cartorio.endereco }}, {{ detalhes_cartorio.bairro }} - {{ detalhes_cartorio.cidade }}</p>
      <div class="text-consulta-modal">
        <b>Telefone: </b>{{ detalhes_cartorio.telefone | fone }} <br>
        <p v-if="detalhes_cartorio.whatsAppPublico == '1' && detalhes_cartorio.nrWhatsApp.length">WhatsApp: <a class="link" :href="`https://wa.me/${detalhes_cartorio.nrWhatsApp.replace(/\D+/, '')}`">{{ detalhes_cartorio.nrWhatsApp | fone }}</a></p>
      </div>
      <hr/>   
      <p class="mt-0 mb-4 text-consulta-modal"><b>Quantidade de protestos:</b> {{ detalhes_cartorio.qtdTitulos }}</p>
      <b-list-group v-for="tituloDocumento in detalhes_cartorio.titulos">
        <b-list-group-item v-for="(tit, index) in tituloDocumento" :key="index" href="#" class="flex-column align-items-start p-4">
          <div class="d-flex w-100 justify-content-between detalhes-cartorio-container">
            <!-- <template v-if="logged && documentoPesquisado==documento">
              <p v-bind:title="tit.nomeApresentante"><b>Apresentante</b><br/>{{ tit.nomeApresentante.substring(0,20)}}{{tit.nomeApresentante.length>20 ? "..." : ""}} </p>
              <p v-bind:title="tit.nomeCedente"><b>Credor</b><br/>{{ tit.nomeCedente.substring(0,20) }}{{tit.nomeCedente.length >20 ? "..." : ""}}</p>
            </template> -->
            <b-row class="w-100">
              <b-col cols="12" md="6">
                <p><b>Documento: </b>
                <the-mask :mask="['###.###.###-##', '##.###.###/####-##']" v-model="tit.cpfCnpj" class="input-documento shadow-sm" disabled style="background-color: transparent !important;padding: 0 !important;border-radius: 0px !important;box-shadow: none !important;" /></p>
              </b-col>
              <!-- <b-col cols="12" md="4">
              <p><b>Data do Protesto</b><br/>{{ tit.dataProtesto }}</p>
              </b-col> -->
              <b-col cols="12" md="6">
                <p v-if="tit.valorProtestado != '0,00'"><b>Valor Protestado: </b>R$ {{ tit.valorProtestado }}</p>
              </b-col>
            </b-row>
          </div>
          <div v-if="tit.temAnuencia != 'false'" class="titulo-anuencia-container d-flex flex-wrap mt-4 "  v-bind:id=tit.nm_chave+index >
            <b-alert :show="tit.temAnuencia != 'false'" variant="warning" class="text-center shadow-sm alerta-anuencia flex-grow-1 mr-4 mb-0" >
              <p>
                Protesto com <b v-if="!tit.anuenciaVencida">autorização de cancelamento - Custas de Cancelamento: R$ {{ tit.vl_custas }}</b>
                <b v-else>autorização de cancelamento </b>
                <!-- <b-button variant="outline-danger" @click="cancProtInativo()" class="btn-sm mt-3 float-right" >Cancelar Protesto</b-button>  -->
              </p>  
            </b-alert>
            <b-button variant="outline-danger" @click="cancProt(tit.nm_chave,index, tit.cpfCnpj, detalheUF, tit.vl_custas, tit.valorProtestado, detalhes_cartorio.codIBGE, detalhes_cartorio.numeroCartorio)"
            class="btn-sm float-right d-flex justify-content-center align-items-center " v-if="tit.vl_custas > 0" >Cancelar protesto</b-button>
            
            <!-- <b-button variant="outline-danger" @click="cancProt_instabilidade()"
            class="btn-sm float-right d-flex justify-content-center align-items-center " v-if="tit.vl_custas > 0" >Cancelar protesto</b-button> -->
             <b-button variant="outline-danger" @click="gerarPedidoZerado(tit.nm_chave)" class="btn-sm float-right d-flex justify-content-center align-items-center " v-else >Cancelar protesto</b-button>
            <p v-if="detalheUF != 'SP'" class="mt-2">
              *Para gerar o pagamento relativo as custas de cancelamento, deve-se estar autenticado no sistema.
            </p>
            <p v-if="detalheUF == 'SP'" class="mt-2">
              *O Cancelamento de protesto, dos Tabelionatos de Protesto de São Paulo, é realizado por meio do site Cenprot SP. Clique no botão ao lado para que seja direcionado.
            </p>
          </div>
          <div v-if="nm_chave == tit.nm_chave && index== linha && tempedido == true" class="alert alert-primary" role="alert">
            <p onclick="javascript:location.href='/painel'">{{ msg_retorno }}<br>Clique aqui para acessar sua lista de pedidos</p>
          </div>
        </b-list-group-item>
      </b-list-group>
    </b-modal>

    <div id="wrapper-spinner" v-if="!exibir">
      <BeatLoader color="var(--main-azul)" />
    </div>
    <div id="resultados" :class="{ certidao: solicitarCertidao }" v-else>
      <!-- CONSTAM PROTESTOS -->
      <div v-if="qtdTitulos > 0 " id="wrapper-estados">
        <b-row class="mb-4">
            <b-col cols="12">
              <div style="display: flex; align-items: center; gap: 8px;">
                  <!-- <h5 style="margin: 0;"> -->
                      <font color="red"><b>Pesquisa realizada pelo usuário:</b></font>
                  <!-- </h5> -->
                  {{ documentoPesquisado | formatar_documento }}, {{ nomePesquisado }}
              </div>

            </b-col>
          </b-row>
        <b-row class="mb-4">
          <b-col cols="6">
            <b-button variant="outline-secondary float-left"  @click="voltar()" >Voltar<img src="~@/assets/imgs/icons/return-icon.svg" /></b-button>
          </b-col>
          <b-col cols="6" v-if="!totem">
            <b-button variant="outline-secondary float-right" :disabled="isImprimindo" @click="imprimirComprovante()"> 
              <div class="texto-Imprimir" :class="{ 'printing-animation': isImprimindo }"></div>
              <div class="printing-loader" :style="{ 'display': ( isImprimindo ? 'flex' : 'none') }">
                <div class="text-loader bg-1ACEB5" :style="{ 'display': ( isImprimindo ? 'flex' : 'none') }" />
                <div class="text-loader bg-209CEE" :style="{ 'display': ( isImprimindo ? 'flex' : 'none') }" />
                <div class="text-loader bg-4780F1" :style="{ 'display': ( isImprimindo ? 'flex' : 'none') }" />
              </div>
              <font-awesome-icon icon="print" class="ml-2" size="2x" />
            </b-button>
          </b-col>
        </b-row>
        <div v-if="solicitarCertidao && servico_certidao">
          <h2 class="pb-1 blueSolicita blue">Solicitar certidão</h2>
          <b-alert  show variant="danger" v-if="titulosSP">
            <a href="https://www.protestosp.com.br/Certidoes/Index" target="_blank" style="color: inherit; text-decoration: none; cursor: pointer;">
              <figure class="flag float-left flag-notificacao">
                <img :src="require('@/assets/imgs/bandeiras/flag-sp.png')">
              </figure>
              Para pedidos de certidão do estado de SP. Clique aqui
            </a>
          </b-alert>
          <!-- <b-card-group deck class="mb-3" >
            <div v-for="(cartorio,uf) in exibeEstados" :key="uf" class="col-12 col-sm-4 col-lg-4 mt-2">
              <b-card  header-tag="header">
                <template v-slot:header>
                  <figure class="flag mr-2 float-left"><img :src="require('@/assets/imgs/bandeiras/flag-'+(uf).toLowerCase()+'.png')"></figure>
                  <h4 class="mb-0">{{ estados[uf] }}</h4>
                </template>
                <b-card-text>
                  Para este estado, favor solicitar através do botão abaixo
                  <br>
                  <b-button variant="outline-primary" class="btn-lg mt-2 float-left" :href="linksOutrosEstados[uf]" target="_BLANK">Solicitar</b-button>
                </b-card-text>
              </b-card>
            </div>
          </b-card-group> -->
            
          <b-card class="mb-3 shadow-sm">
            <h4 class="card-title">Informações do pesquisado</h4>
            <b-card-text>
              <div class="row">
                <div class="form-group col-sm-5">
                  <label for="nome_completo">Nome completo do pesquisado:</label>
                  <b-form-input id="nome_completo" ref="nome_completo" v-model="nome_completo" :state="nome_completo_state"></b-form-input>
                </div>
                <div class="form-group col-sm-4">
                  <label for="nome_completo">Documento do pesquisado:</label>
                  <b-input
                    ref="documento_solicitante"
                    v-model="documento_solicitante"
                    placeholder="Documento pesquisado"
                    maxlength="18"
                    :state="validation_documento_solicitante"
                    id="outorgado_documento"
                    :formatter="formatadocumento"
                    required
                  >
                  </b-input>
                  <b-form-invalid-feedback :state="validation_documento_solicitante">Infome um documento válido.</b-form-invalid-feedback>
                </div>
                <div class="form-group col-sm-3">
                  <label for="nome_completo">RG do pesquisado:</label>
                  <b-form-input
                    ref="rg_pesquisado"
                    v-model="rg_pesquisado"
                    maxlength="18"
                    required
                    :state="validation_rg_pesquisado"
                    placeholder="RG pesquisado"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback :state="validation_rg_pesquisado">Infome um RG válido.</b-form-invalid-feedback>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-3">
                  <label for="cep_pesquisado">CEP:</label>
                  <b-form-input id="cep_pesquisado" ref="cep_pesquisado" v-model="pesquisado_cep" :state="validations.pesquisado_cep" :formatter="cep"></b-form-input>
                </div>
                <div class="form-group col-sm-7">
                  <label for="inputEmail4">Endereço:</label>
                  <b-form-input id="endereco_pesquisado" ref="endereco_pesquisado" v-model="dadosPesquisado.endereco" :state="validations.pesquisado_endereco"></b-form-input>
                </div>
                <div class="form-group col-sm-2">
                  <label>UF:</label>
                  <b-form-input v-model="sg_uf" :state="validations.pesquisado_uf"></b-form-input>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-3">
                  <label for="cidade_pesquisado">Cidade:</label>
                  <b-form-input id="cidade_pesquisado" ref="cidade_pesquisado" v-model="dadosPesquisado.cidade" :state="validations.pesquisado_cidade"></b-form-input>
                </div>
                <div class="form-group col-sm-4">
                  <label for="bairro_pesquisado">Bairro:</label>
                  <b-form-input id="bairro_pesquisado" ref="bairro_pesquisado" v-model="dadosPesquisado.bairro" :state="validations.pesquisado_bairro"></b-form-input>
                </div>
                <div class="form-group col-sm-5">
                  <label for="email_pesquisado">E-mail:</label>
                  <b-form-input id="email_pesquisado" ref="email_pesquisado" v-model="dadosPesquisado.email"></b-form-input>
                </div>
                <div class="form-group col-sm-5">
                  <label for="email_pesquisado">Motivo da Solicitação:</label>
                  <b-form-textarea
                    id="motivo_solicitacao"
                    v-model="motivo_solicitacao"
                    placeholder="Digite o motivo da solicitação"
                    rows="3"
                    max-rows="6"
                    :state="motivo_solicitacaoState"
                  ></b-form-textarea>
                  <b-form-invalid-feedback :state="motivo_solicitacaoState">
                    Preencha no minimo 10 caracteres.
                  </b-form-invalid-feedback>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-6">
                  <b-form-radio v-model="infocert" name="sol-cert" value="D">Certidão Digital</b-form-radio>
                </div>
                <!-- <div class="form-group col-sm-6">
                  <b-form-radio v-model="infocert" name="sol-cert" value="O">Outros meios</b-form-radio>
                </div> -->
              </div>
              <b-row v-if="infocert==='D'">
                <b-col>
                <!-- <b-alert show variant="light" class="shadow-sm text-center" v-if="showOption==='T'"> -->
                  <h6 class="mt-3 mb-0 blue text-center">Pedido de certidão digital.</h6>
                <!-- </b-alert>-->
                </b-col>
              </b-row>
            </b-card-text>
          </b-card>
          <b-card header="Informações de entrega" class="text-center mt-3 bold shadow" v-if="infocert=='O'">
            <div class="text-center">
              <b-card-text>
                <b-form-group>
                  <b-row>
                    <b-col>
                      <b-form-radio v-model="showOption" name="some-radios" value="C">Correios/ Sedex</b-form-radio>
                    </b-col>
                    <b-col>
                      <b-form-radio v-model="showOption" name="some-radios" value="T">Retirar no cartório</b-form-radio>
                    </b-col>
                  </b-row>
                  <b-row v-if="showOption==='T'">
                    <b-col>
                      <!-- <b-alert show variant="light" class="shadow-sm text-center" v-if="showOption==='T'"> -->
                        <!-- <h6 class="mt-3 mb-0 blue">Pedido de certidão digital.</h6> -->
                      <!-- </b-alert>-->
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-card-text>
            </div>
          </b-card>
          <b-card-group deck v-show="showOption === 'C' && infocert !=='D'">
            <b-card header="Valor do Envio" class="text-center bold shadow mt-3">
              <b-card-text>
                <b-row>
                  <b-col cols="12" md="12" lg="4">
                    <b-row class="my-1">
                      <b-col sm="4">
                        <label for="CEP">Calcular envio</label>
                      </b-col>
                      <b-col sm="8">
                        <b-row>
                          <b-col md="9">
                            <b-form-group >
                              <!-- <the-mask :mask="['########']" id="cep" class="form-control" v-model="service.cep" placeholder="Digite o CEP" @click="checkCep" :state="null" /> -->
                              <b-form-input id="cep" v-model="service.cep" :state="calcEnvioState" type="text" @keypress="maxLength" @keyup="mascaraCep" @paste="ficaOito"></b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col md="3">
                            <b-button variant="primary" @click.prevent="calcular_frete">OK <b-spinner id="loading-solicitante" small type="grow" v-if="loading"></b-spinner></b-button>
                          </b-col>
                        </b-row>
                        <b-row v-if="this.aCepOrigem.length==0">
                          <b-col md="12">
                            <b-form-group>
                              <p><font color="red">Selecione ao menos um cartório</font></p>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" md="12" lg="3">
                    <b-row class="my-1">
                      <b-col sm="8">
                        <div v-show="showLoad" class="load">
                          <div class="spin"></div>
                          <div class="loading">CARREGANDO</div>
                        </div>
                        <label v-show="nameLoad" v-if="!erroCep" for="frete">
                          <p><b>Valor: R${{ service.valor}}</b></p>
                        </label>
                      </b-col>
                      <b-col sm="4"><p></p></b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" md="12" lg="3" v-if="!erroCep">
                    <b-row class="my-1">
                      <b-col sm="8">
                        <label v-show="nameLoad" for="frete"><p><b>Prazo: {{ service.prazo }} dia(s) úteis </b></p></label>
                      </b-col>
                      <b-col sm="4"><p></p></b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <p v-show="nameLoad" v-if="!erroCep"><b>Endereço: </b>{{ solicitante.endereco+(solicitante.complemento ? ' - '+ solicitante.numero +' - '+solicitante.complemento : '')+' - '+solicitante.bairro+' - '+solicitante.municipio+' - '+solicitante.uf }}</p>
                <b-row v-show="nameLoad" v-if="!erroCep">
                  <b-col cols="12" lg="8"  class="text-center">
                    <div class="form-group row">
                      <label for="numero" class="col-4 col-sm-2 col-form-label text-right">Endereço</label>
                      <div class="col-8 col-sm-10" >
                        <!-- <input id="numero" name="numero" type="text" v-model="solicitante.numero"  class="form-control" :state="false"> -->
                        <b-form-input id="endereco"  name="endereco" v-model="solicitante.endereco" :state="enderecoState"></b-form-input>
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="12" lg="4"  class="text-right">
                    <div class="form-group row">
                      <label for="numero" class="col-4 col-sm-5 col-form-label">Nº</label>
                      <div class="col-8 col-sm-6" >
                        <!-- <input id="numero" name="numero" type="text" v-model="solicitante.numero"  class="form-control" :state="false"> -->
                        <b-form-input id="numero"  name="numero" v-model="solicitante.numero" :state="numeroState" type="number"></b-form-input>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-show="nameLoad" v-if="!erroCep">
                  <b-col cols="12" md="4">
                    <div class="form-group row">
                      <label for="bairro" class="col-4 col-form-label text-right">Bairro</label>
                      <div class="col-8">
                        <b-form-input id="bairro" name="bairro" type="text" v-model="solicitante.bairro" class="form-control" :state="bairroState"></b-form-input>
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="12" md="4">
                    <div class="form-group row">
                      <label for="municipio" class="col-4 col-sm-5 col-form-label text-right">Cidade</label>
                      <div class="col-8 col-sm-7">
                        <b-form-input id="municipio" name="municipio" type="text" v-model="solicitante.municipio" class="form-control" :state="municipioState"></b-form-input>
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="12" md="4">
                    <div class="form-group row">
                      <label for="complemento" class="col-4 col-sm-5 col-form-label text-right">Complemento</label>
                      <div class="col-8 col-sm-7">
                        <input id="complemento" name="complemento" type="text" v-model="solicitante.complemento" class="form-control">
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-if="erroCep">
                  <b-col cols="12" md="12">
                    <div>
                      <b-alert show variant="danger" class="text-center">Dados do CEP não localizado</b-alert>
                    </div>
                  </b-col>
                </b-row>
              </b-card-text>
            </b-card>
          </b-card-group>
          <b-alert v-if="alert_cartorios" show variant="danger" class="text-center">Selecione os cartórios onde deseja solicitar certidões!</b-alert>
          <div class="pb-3 overflow-auto">
            <div class="float-right">
              <b-form-checkbox
                v-model="selecionar_todos"
                class="selecionar-todos">Selecionar todos</b-form-checkbox>
            </div>
          </div>
        </div>
        <div v-else>
          <!-- RESULTADO DE CONSTAM PROTESTOS -->
          <b-row class="mb-4">
            <b-col cols="8">
              <h2 class="pb-3 blueSolicita blue">Resultados</h2>
            </b-col>
          </b-row>
          <b-alert show variant="light shadow-sm mb-5 cardCel">
            <h4 class="alert-heading text-danger">Constam protestos nos cartórios participantes do Brasil</h4>
            <p>As informações referem-se a pesquisa, não valendo como certidão ou prova de inadimplemento e apenas tendo valor legal após confirmação por certidão no Tabelionato indicado.</p>
            <hr>
            <p class="mb-0">
              Para consultar os cartórios participantes do Brasil, <a @click="participantes()" class="link">clique aqui</a>
            </p>
            <div>
              <b-link @click="protestosCancelamento()" v-if="!logged && titulosAnuido">Para consultar protesto com autorização de cancelamento  - clique aqui</b-link>
            </div>
          </b-alert>
          <b-container class="bv-example-row mb-4">
            <b-row>
              <b-col cols="12" md="6" class="p-0 textoInformativo">
                <b>Documento informado:</b>
                <the-mask
                  :mask="['###.###.###-##', '##.###.###/####-##']"
                  v-model="documento" class="input-documento shadow-sm" disabled />
              </b-col>
              <b-col cols="12" md="6" class="p-0 textoInformativo">
                <b>Data da consulta:</b> {{ dataConsulta }}
              </b-col>
            </b-row>
            <br>
            <b-alert  show variant="warning" v-if="documento.length > 11">
              {{(mobile?'CNPJ: Pesquisa realizada pela raiz listará protesto de suas filiais.':'Pesquisa realizada pela raiz do CNPJ. Serão listados protesto de todas filiais.')}}
            </b-alert>
            <b-alert  show variant="danger" v-if="titulosAnuido">
              <a @click="protestosCancelamento()" style="color: inherit; text-decoration: none; cursor: pointer;">
                {{(mobile?'Títulos com autorização para cancelamento. Clique aqui':'Títulos protestados com autorização para cancelamento disponível. Clique aqui')}}
              </a>
            </b-alert>
            <b-alert  show variant="danger" v-if="titulosSP">
              <a href="https://www.protestosp.com.br/Certidoes/Index" target="_blank" style="color: inherit; text-decoration: none; cursor: pointer;">
                <figure class="flag float-left flag-notificacao"><img :src="require('@/assets/imgs/bandeiras/flag-sp.png')"></figure>
                Para pedidos de certidão do estado de SP. Clique aqui
              </a>
            </b-alert>
          </b-container>
          <b-container class="bv-example-row mb-4">
            <b-row>
            <div class="col-sm-12" v-if="status === 'error'">
                <p v-if="mensagem[0]=='LIMITE DIARIO PARA CONSULTA EXCEDIDO'" class="alert alert-danger">Atenção: SP - Falha na comunicação </p>
                <p v-else-if="mensagem[0] == 'Falha na integração com SP'" class="alert alert-danger">Atenção: Sem comunicação com SP</p>
            </div>
            </b-row>
          </b-container>
        </div>
      
        <section class="segment" v-for="(cartorio, uf) in UFs" :key="uf">
          <header>
            <figure class="flag mr-3 float-left"><img :src="require('@/assets/imgs/bandeiras/flag-'+(uf).toLowerCase()+'.png')"></figure>
            <h3 class="blue">{{ estados[uf] }}
            <!-- <b-button v-if="estadosBloqueados[uf]" variant="outline-primary" class="btn-lg mb-2 float-right" :href="linksOutrosEstados[uf]" target="_BLANK" title="Para este estado, favor solicitar através deste botão">Solicitar</b-button> -->
          </h3>
          </header>
          <b-table class="small" striped hover :fields="solicitarCertidao ? fields_edit : mobile ? mobile_fields : fields" :items="cartorio">

            <template slot="HEAD_qtdTitulos" slot-scope="data">
              <p class="m-0 p-0">{{ data.label }}</p>
            </template>
            <template slot="qtdTitulos" slot-scope="data">
              <p class="m-0 p-0">{{ data.item.qtdTitulos }}</p>
            </template>

            <template v-if="solicitarCertidao" slot="HEAD_selected" slot-scope="data">
              <p class="m-0 p-0">{{ data.label }}</p>
            </template>
            <template v-if="solicitarCertidao && !estadosBloqueados[uf]" slot="selected" slot-scope="row">
              <b-form-group class="mb-0">
                <input type="checkbox" v-model="row.item.selected" @click="selectClickedRow(row.item)" />
              </b-form-group>
            </template>

            <template slot="HEAD_periodo" slot-scope="data">
              <p class="m-0 p-0">{{ data.label }}</p>
            </template>
            <template #cell(periodo)>
              <b-form-group class="mb-0">
                5 anos
              </b-form-group>
            </template>

            <template slot="HEAD_acoes" slot-scope="data">
              <p class="m-0 p-0">{{ data.label }}</p>
            </template>
            <template #cell(acoes) = "row">
              <b-form-group class="mb-0">
                <b-button variant="outline-primary" class="btn-sm" style="min-width: 100px;" @click="ver_detalhes(row.item,uf)" v-if="uf !='SP'">Detalhes</b-button>
                <b-button variant="outline-primary" class="btn-sm" style="min-width: 100px;" @click="exibe_detalhesp(row.item)" v-if="uf =='SP'">Detalhes</b-button>
              </b-form-group>
            </template>

            <!-- sub item -->
            <template slot="acoesEdit" slot-scope="row" v-if="!estadosBloqueados[uf]">
              <b-button size="sm" @click="row.toggleDetails" class="mr-2">
                {{ row.detailsShowing ? 'Esconder' : 'Exibir'}} Titulos
              </b-button>
            </template>
           
            <template v-slot:row-details="row" v-if="solicitarCertidao && !estadosBloqueados[uf]">
              <section>
                <b-table
                :ref="row.item.cidade + row.item.numeroCartorio"
                :items="row.item.titulos"
                :fields="fields_sub"
                >
                 
                <template #cell(lSelected)="rowSub">
                  <input type="checkbox" v-model="rowSub.item.selected" />
                </template>
                <template #cell(lDocumento)="rowSub">
                  {{rowSub.item.cpfCnpj | documento}}
                </template>
                <!-- <template slot="lDataProtesto" slot-scope="rowSub">
                  {{rowSub.item.dataProtesto}}
                </template>
                <template slot="lDataVencimento" slot-scope="rowSub" >
                  {{rowSub.item.dataVencimento}}
                </template>
                <template slot="lValorProtestado" slot-scope="rowSub">
                  {{rowSub.item.valorProtestado}}
                </template> -->
                </b-table>
              </section>
            </template>
          </b-table>
        </section>
      </div>

      <!-- NÃO CONSTAM PROTESTOS -->
      <div v-else id="wrapper-estados">
        <div>
          <!-- RESULTADO DE NÃO CONSTAM PROTESTOS -->
          <b-row class="mb-4">
            <b-col cols="12">
              <div style="display: flex; align-items: center; gap: 8px;">
                  <!-- <h5 style="margin: 0;"> -->
                      <font color="red"><b>Pesquisa realizada pelo usuário:</b></font>
                  <!-- </h5> -->
                  {{ documentoPesquisado | formatar_documento }}, {{ nomePesquisado }}
              </div>

            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="6">
              <b-button variant="outline-secondary float-left"  @click="voltar()">Voltar<img src="~@/assets/imgs/icons/return-icon.svg" /></b-button>
            </b-col>
            <b-col cols="6" v-if="!totem">
              <b-button variant="outline-secondary float-right" :disabled="isImprimindo" @click="imprimirComprovante()"> 
                <div class="texto-Imprimir" :class="{ 'printing-animation': isImprimindo }"></div>
                <div class="printing-loader" :style="{ 'display': ( isImprimindo ? 'flex' : 'none') }">
                  <div class="text-loader bg-1ACEB5" :style="{ 'display': ( isImprimindo ? 'flex' : 'none') }" />
                  <div class="text-loader bg-209CEE" :style="{ 'display': ( isImprimindo ? 'flex' : 'none') }" />
                  <div class="text-loader bg-4780F1" :style="{ 'display': ( isImprimindo ? 'flex' : 'none') }" />
                </div>
                <font-awesome-icon icon="print" class="ml-2" size="2x" />
              </b-button>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="8">
              <h2 class="pb-3 blueSolicita blue">Resultados</h2>
            </b-col>
          </b-row>
          <b-alert show variant="light shadow-sm mb-5 cardCel">
            <h4 class="alert-heading text-success">Não constam protestos nos cartórios participantes do Brasil</h4>
            <p>As informações referem-se a pesquisa, não valendo como certidão ou prova de inadimplemento e apenas tendo valor legal após confirmação por certidão no Tabelionato indicado.</p>
            <hr>
            <p class="mb-0">
              Para consultar os cartórios participantes do Brasil, <a @click="participantes()" class="link">clique aqui</a>
            </p>
          </b-alert>
          <b-container class="bv-example-row mb-4">
            <b-row>
              <b-col cols="12" md="5" class="p-0 doc"><b>Documento informado:</b> <the-mask
                      :mask="['###.###.###-##', '##.###.###/####-##']"
                      v-model="documento" class="input-documento shadow-sm" disabled /></b-col>
              <b-col cols="12" md="4" class="Data"><b>Data da consulta:</b> {{ dataConsulta }}</b-col>
              <b-col cols="12" md="3" class="p-0 text-center">Pesquisa retroativa de 5 anos</b-col>
            </b-row>
          </b-container>
          <b-container class="bv-example-row mb-4">
          
            <b-row>
            <div class="col-sm-12" v-if="status === 'error'">
                <p v-if="mensagem[0]=='LIMITE DIARIO PARA CONSULTA EXCEDIDO'" class="alert alert-danger">Atenção: SP - Falha na comunicação </p>
                <p v-else-if="mensagem[0] == 'Falha na integração com SP'" class="alert alert-danger">Atenção: Sem comunicação com SP</p>
            </div>
            </b-row>
          </b-container>
        </div>
      </div>
      <div class="barra-consulta">
        <div class="row row-botoes-consulta">
          <div class="float-left" v-if="qtdTitulos > 0 && solicitarCertidao">
            <b-button @click="$router.push({ name: 'home' })" variant="outline-secondary" class="btn-lg">Cancelar</b-button>
          </div>
          <div class="float-right" v-if="!totem && servico_certidao">
            <!-- <span v-if="solicitarCertidao">
              {{ 
                titulosSelecionados == 0 ? 'Nenhum título selecionado' : 
                  titulosSelecionados + (titulosSelecionados == 1 ? ' título foi selecionado' : ' títulos foram selecionados' )
              }}
            </span> -->
            <b-button variant="primary" class="btn-solicitar-certidao" :class="{ 'finalizar-solicitacao': solicitarCertidao }" @click="solicitar()">{{ solicitarCertidao ? 'Enviar solicitação' : 'Solicitar Certidão'}}</b-button>
          </div>
        </div>
      </div>
      
      <!-- <div id="barra-footer" class="shadow-lg">
        <div class="row pl-2 pr-2 d-flex justify-content-between flex-nowrap">
          <div class="float-left" v-if="qtdTitulos > 0 && solicitarCertidao">
            <b-button @click="$router.push({ name: 'home' })" variant="outline-secondary" class="btn-lg">Cancelar</b-button>
          </div>
          <div class="com-sm-2 text-left" v-if="qtdTitulos > 0 && servico_certidao">
            <b-button v-if="!totem" variant="success" class="btn-lg" @click="solicitar()">Solicitar certidão</b-button>
            <b-button v-else variant="outline-secondary" class="btn-lg mt-2 float-Left ml-4 d-none d-xl-block" @click="!totem ? $router.push({ name: 'home' }) : $router.push({ name: 'totem' })">Voltar</b-button>
          </div>
          <div class="" v-if="qtdTitulos == 0 && servico_certidao && !totem">
            <!-- <b-button variant="success" class="btn-lg" @click="() => { if(cadastroCompleto) $router.push({ name: 'certidaoNegativa' });}">Solicitar Certidão</b-button> -->
            <!-- <b-button variant="success" class="btn-lg" @click="() => { $router.push({ name: 'certidaoNegativa' }); }">Solicitar Certidão</b-button> -->
            <!-- <b-button variant="success" class="btn-sm d-block d-xl-none" @click="$router.push({ name: 'certidaoNegativa' })">Solicitar Certidão</b-button> -->
          <!-- </div>
          <div class="com-sm-2 text-right mt-2" v-if="!totem">
            <b-button variant="danger" class="btn-lg" @click="imprimirComprovante()">Imprimir</b-button>
          </div>
        </div>
      </div> -->
    </div>
    <vue-recaptcha
      ref="invisibleRecaptcha"
      :load-recaptcha-script="true"
      @verify="onVerify"
      @expired="onExpired"
      size="invisible"
      :sitekey="sitekey"
      badge="bottom"
      v-bind:style="totem ? {display: 'none'} : ''"
      ></vue-recaptcha> 
        

    <footersite class="d-none d-xl-block" v-if="!totem" />
    <footersitemobile class="d-block d-xl-none" v-if="!totem" />
  </div>
</template>

<script>
import { TheMask } from 'vue-the-mask'
import Header from '../components/Header'

import BeatLoader from 'vue-spinner/src/BeatLoader.vue'
import API from '../services/api'
import { setTimeout } from 'timers'
import axios from "axios"

import CryptoJSAesJson from "../services/CryptoJSAesJson";
import Serv from '../services'

import protestoanuenciacancelamento from "../components/protesto_anuencia_cancelamento";
import footersite from "../components/footersite";
import footersitemobile from "../components/footersite/index_mobile";
import VueRecaptcha from "vue-recaptcha";
import '@parcelaexpress/checkout-component-js';



export default {
  props: ['documento', 'solicitarCertidao', 'captcha', 'totem'],
  components: {
    Header,
    BeatLoader,
    TheMask,
    protestoanuenciacancelamento,
    footersite,
    footersitemobile,
    VueRecaptcha

  },
data() {
    return {
      sitekey: process.env.VUE_APP_sitekeyRecaptchaInvisivelV2,
      ip_maquina:null,
      cadastroCompleto:false,
      items: [],
      msgValida:'',
      detalheUF:'null',
      token_captcha:null,
      consulta_detalhe:false,
      titulosAnuido: false,
      logged: false,
      mobile: window.innerWidth < 1200,
      erroCep : false,
      alert_cartorios: false,
      tempedido :false,
      index :'null',
      linha:'null',
      nm_chave:'null',
      loading:false,
      msg_retorno:'',
      // doc = 00000758834225
      UFs: {},
      ds_endereco_boleto:null,
      documentoPesquisado:null,
      nomePesquisado:null,
      sg_uf:null,
      rg_pesquisado:null,
      erroCertidao:null,
      erroPushMsg:'',
      erroPushRoute:{name:'painel'},
      motivo_solicitacao:'',
      documento_solicitante:'',
      exibeRG:false,
      dadosPesquisado:{
        cep:'',
        endereco:'',
        uf:'',
        cidade:'',
        bairro:'',
        email:''
      },
      aCepOrigem: [],
      nameLoad: false,
      showLoad: false,
      showOption: "T",
      infocert: "D",
      //loading: false,
      cartorios: [],
      certidao: true,
      show: true,
      toggle: false,
      certidoes: [],
      cd_certidao: null,
      solicitante:{
          nome: '',
          documento:'',
          email: '',
          celular: '',
          endereco: '',
          numero: '',
          complemento: '',
          bairro: '',
          municipio: '',
          uf: ''
      },
      service:{
          cep: '',
          valor: '',
          entrega: '',
          codigo: ''
      },
      qtdTitulos: 0,
      total_cartorios: 0,
      servico_complementar: {},
      exibir: false,
      estados: {
        'AC': 'Acre',
        'AL': 'Alagoas',
        'AP': 'Amapá',
        'AM': 'Amazonas',
        'BA': 'Bahia',
        'CE': 'Ceará',
        'DF': 'Distrito Federal',
        'ES': 'Espírito Santo',
        'GO': 'Goiás',
        'MA': 'Maranhão',
        'MT': 'Mato Grosso',
        'MS': 'Mato Grosso do Sul',
        'MG': 'Minas Gerais',
        'PA': 'Pará',
        'PB': 'Paraíba',
        'PR': 'Paraná',
        'PE': 'Pernambuco',
        'PI': 'Piauí',
        'RJ': 'Rio de Janeiro',
        'RN': 'Rio Grande do Norte',
        'RS': 'Rio Grande do Sul',
        'RO': 'Rondônia',
        'RR': 'Roraíma',
        'SC': 'Santa Catarina',
        'SP': 'São Paulo',
        'SE': 'Sergipe',
        'TO': 'Tocantins'
      },
      estadosBloqueados:{
        'SP': true,
        //'MG': true,
        //'MT': true,
        //'RJ': true,
        //'DF': true,
        //'TO': true 
      },
      exibeEstados:{},
      linksOutrosEstados: {
        'SP': 'https://www.protestosp.com.br/Certidoes/Index',
        'MG': 'http://central.ieptbmg.com.br/certprot/usuarios/sign_in',
        'MT': 'https://cei-anoregmt.com.br/Sistema/',
        'RJ': 'http://ieptbrj.cancelamentoprotesto.com.br/usuarios/sign_in?certidao=true',
        'DF': 'http://protestofacil.com/',
        'TO':  'https://cartoriostocantins.com.br/certidaoonline'
      },
      mobile_fields: [
          {label: 'Cartório', key: 'nomeCartorio'}, 
          {label: 'Ações', key:'acoes'}
      ],
      fields: [
          {label: 'Cartório', key: 'nomeCartorio'}, 
          {label: 'Cidade', key:'cidade'}, 
          {label: 'Qtd. de títulos', key:'qtdTitulos'},
          {label: 'Período da pesquisa', key:'periodo'} ,
          {label: 'Ações', key:'acoes'}
      ],
      fields_edit: [
        {key: 'selected',  label: 'Selecionar' },
        {key: 'nomeCartorio',  label: 'Cartório' },
        {key: 'cidade', label: 'Cidade' },
        {key: 'qtdTitulos',  label: 'Qtd. de títulos' },
        {key: 'acoesEdit', label: 'Ações' }
      ],
      fields_sub:[
        {key: 'lSelected',  label: 'Selecionar' },
        {key: 'lDocumento', label:'Documento'},
        //lDataProtesto: {label:'Data do Protesto'},
        //lDataVencimento: {label:'Data de Vencimento'},
        //lValorProtestado: {label:'Valor do Protestado'}
      ],
      selecionar_todos: false,
      pesquisado_cep:'',
      cartorios_selecionados: [],
      nome_completo: '',
      nome_completo_state: null,
      calcEnvioState : null,
      numeroState: null,
      bairroState: null,
      enderecoState: null,
      municipioState: null,
      motivo_solicitacaoState:null,
      enviaCep: null,
      detalhes_cartorio: [],
      validation_documento_solicitante:null,
      validation_rg_pesquisado:null,
      validations: {
        pesquisado_cep: null,
        pesquisado_endereco: null,
        pesquisado_uf: null,
        pesquisado_cidade: null,
        pesquisado_bairro: null,
      },
      servico_cancelamento: false,
      servico_anuencia: false,
      servico_certidao: false,
      servico_protesto: false,
      dataConsulta: new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString(),
      status: "",
      CLIENT_KEY_EXPRESS: process.env.VUE_APP_CLIENT_KEY_EXPRESS,
      SELLER_KEY_EXPRESS: process.env.VUE_APP_SELLER_KEY_EXPRESS,
      URL_EXPRESS: process.env.VUE_APP_URL_EXPRESS,
      ENVIRONMENT_EXPRESS: process.env.VUE_APP_ENVIRONMENT_EXPRESS,
      sizemodalboleto: "xl",
      boletoSelecionado: {},
      formaPagamento: 0,
      formasPagamento: [
        { text: "Selecione uma opção de pagamento", value: 0 },
        { text: "BOLETO - Parcela Express (Tarifa Bancária - R$ 0,87)", value: 2 },//comentado até virada da tabela de custas
        { text: "PIX - Parcela Express (Gratuito)", value: 3 },
      ],
      secondcd: 30,
      pdf: null,
      sizemodalboleto: "xl",
      linkPIX: "",
      mensagemBolErro: "",
      isImprimindo: false,
      titulosSP: false,
    };
  },
  methods: {
    onExpired: function() {
      this.$refs.invisibleRecaptcha.reset();
    },
    resetRecaptcha() {
      this.$refs.invisibleRecaptcha.reset(); // Direct call reset method
    },
    getPermicaoServico: function() {
      this.loading = true;
      const token = localStorage.getItem("jwtToken");
      this.servico_cancelamento = true;
      this.servico_anuencia = true;
      this.servico_certidao = true;
      this.servico_protesto = true;
    },
    cancProtInativo() {
      this.erroCertidao =
        "Devido à alteração da tabela de custas e emolumentos nos Estados, os serviços da Cenprot estão temporariamente suspensos até dia 04/01, data da publicação das novas tabelas.";
      this.$refs["erro"].show();
    },
    validarDocumento: function(value) {
      let documento = value
        .replace(".", "")
        .replace(".", "")
        .replace("-", "")
        .replace("/", "");
      if (documento.length > 11) {
        if (this.sg_uf == "MS") this.exibeRG = false;
        if (!Serv.validarCNPJ(documento)) this.validation_documento_solicitante = false;
        else this.validation_documento_solicitante = true;
      } else {
        if (this.sg_uf == "MS") this.exibeRG = true;
        if (!Serv.validarCPF(documento)) this.validation_documento_solicitante = false;
        else this.validation_documento_solicitante = true;
      }
    },
    formatadocumento: function(event) {
      var value = event;
      if (value == null) {
        return "";
      } else {
        let v = value;
        //Remove tudo o que não é dígito
        v = v.replace(/\D/g, "");
        if (v.length < 14) {
          //CPF
          //Coloca um ponto entre o terceiro e o quarto dígitos
          v = v.replace(/(\d{3})(\d)/, "$1.$2");
          //Coloca um ponto entre o terceiro e o quarto dígitos
          //de novo (para o segundo bloco de números)
          v = v.replace(/(\d{3})(\d)/, "$1.$2");
          //Coloca um hífen entre o terceiro e o quarto dígitos
          v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
        } else {
          //CNPJ
          //Coloca ponto entre o segundo e o terceiro dígitos
          v = v.replace(/^(\d{2})(\d)/, "$1.$2");
          //Coloca ponto entre o quinto e o sexto dígitos
          v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
          //Coloca uma barra entre o oitavo e o nono dígitos
          v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
          //Coloca um hífen depois do bloco de quatro dígitos
          v = v.replace(/(\d{4})(\d)/, "$1-$2");
        }
        return v;
      }
    },
    async atualizaPagamento(salle_id){
      const token = localStorage.getItem('jwtToken'),  res = await API.post('certidao/atualizaPagamentocc', {token: token, cd_pedido: this.boletoSelecionado.cd_pedido, vl_tarifa:this.percent_value, salle_id: salle_id})
      if(res.data.situacao == true) {
        this.$refs['modalLoading'].hide();
        this.$refs['modalPagamento'].hide();
        this.percent_value = null
        this.get_certidoes();
      }

    },
    // calcula_valor_pagamento(){
    //   this.percent_value =  this.get_percent_val(this.boletoSelecionado.vl_orcServ,2.89)
    //   let valor_pagamento = parseFloat(this.boletoSelecionado.vl_orcServ) + this.percent_value;
    //   return valor_pagamento.toFixed(2);

    // },
    get_percent_val(val, percent){
      let percent_val =(parseFloat(val) * parseFloat(percent)) / 100;
      return parseFloat(percent_val.toFixed(2));

    },
    exibe_detalhesp(item){
      this.item = item
      this.consulta_detalhe = true
      this.$refs.invisibleRecaptcha.reset();
      this.$refs.invisibleRecaptcha.execute();
    },
    copiarLink(){
        var copyTextarea = this.$refs.copiar
        
        copyTextarea.select();

        try {
          var successful = document.execCommand('copy');
          var msg = successful ? 'Texto copiado!' : 'Texto não copiado !';
          alert(msg);
        } catch (err) {
          alert('Opa, Não conseguimos copiar o texto, é possivel que o seu navegador não tenha suporte, tente usar Crtl+C.');
        }
      
    },
    gerarPedidoZerado(nm_chave){
      let self = this
      const token = localStorage.getItem('jwtToken')
      this.boletoSelecionado.token = token;
      this.boletoSelecionado.nm_chave = nm_chave;
      this.boletoSelecionado.consulta = 1;
      API.post(`cancelamento/gerarPedido`, self.boletoSelecionado).then( (res) => {
            self.boletoSelecionado.cd_pedido = res.data.cd_pedido

            if(res.data.situacao == 1)this.msgValida = 'O pedido de número ' + res.data.cd_pedido + ' foi gerado. Assim que o cartório informar os valores dos emolumentos, as opções de pagamento estarão disponíveis no menu "Pedido de Cancelamento > Todos os Pedidos'
            else this.msgValida = res.data.mensagem
            
            this.$refs['modalErro'].show();
      })

    },
    async alteraFPG(){
      this.percent_value = null
      // let valor_calculado = this.calcula_valor_pagamento();
      let self = this
      let retornoIP = await axios.get(`https://api.ipify.org/?format=json`)
      
      const token = localStorage.getItem('jwtToken')
      let costumerBillinAdrres =  await API.get(`usuario/logado/endereco?token=${token}`)
      costumerBillinAdrres = costumerBillinAdrres.data
      
     
      setTimeout(function () {
        const web_component = document.querySelector('parcela-checkout');
        let dadosFormaPagamento = self.formasPagamentoExpress.filter( d => d.code == self.formaPagamento)[0]
        let amount_cents = dadosFormaPagamento != undefined ? parseInt(dadosFormaPagamento.total_amount_cents) : '';
        // console.log(self.boletoSelecionado)

        if(self.formaPagamento.toString().includes("credit") == true)
        {
          API.post(`cancelamento/gerarPedido`, self.boletoSelecionado).then( (res) => {
            self.boletoSelecionado.cd_pedido = res.data.cd_pedido
            let description = 'Pagamento Pedido de ' + (self.boletoSelecionado.cd_produto == 3 ? 'Cancelamento Protesto' : 'Certidao ') +  'N: ' + res.data.cd_pedido;

          
            web_component.customerData = {
             amount_cents: amount_cents,
             description: description,
             form_payment: "credit",
             installment_plan: {
               number_installments: dadosFormaPagamento.installment,
             },
             customer: {
               email: localStorage.getItem('usrEmail'),
               ip: retornoIP.data.ip,
               first_name: localStorage.getItem('usrName'),
               last_name: " ",
               document: localStorage.getItem('usrCpf'),
               billing_address: {
                city: costumerBillinAdrres.cidade || 'São Paulo',
                country: costumerBillinAdrres.pais || 'Brasil',
                house_number_or_name: costumerBillinAdrres.numero || '377',
                postal_code: costumerBillinAdrres.cep ? costumerBillinAdrres.cep.replace('-','') : '01009906',
                state: costumerBillinAdrres.estado || 'SP',
                street: costumerBillinAdrres.rua || 'Rua Líbero Badaró',
              },
             },
             extract_identification:'IEPTB-BR',
             pre_capture: false,
             has_split_rules: false,
             confirmation_required: false,
           };
         
           web_component.onChange = () => 
             {
               // console.log(state);
             }
           
             web_component.beforeSubmit  = () => self.$refs['modalLoading'].show();
           
             web_component.onSubmit = (state) => {
              self.$refs['modalLoading'].show();
              if(state.resultCode == 'Authorised')
              {
                self.atualizaPagamento(state.sale_id);
              }
              else
              {
                self.$refs['modalLoading'].hide();
                self.$refs['ModalPagamentoCartao'].show();
              }
            };
        })
        }
        },1)
    },
    async simulacaoPagamentos(vlr_simulacao){
      let valor_simulado = parseFloat(vlr_simulacao).toFixed(2).replace('.','') / 1
      let resSimulacao = await axios.get(`${process.env.VUE_APP_URL_EXPRESS}/v1/simulation/sellers/${process.env.VUE_APP_SELLER_KEY_EXPRESS}?amount_cents=${valor_simulado}`);
      // console.log(resSimulacao.data)
      // resSimulacao = JSON.parse(resSimulacao.data);
      // console.log(resSimulacao.installment_amount_cents)
      let formasPagamentoSimulacao = resSimulacao.data.filter( d => d.type == 'credit')
      let self = this
      this.formasPagamentoExpress = formasPagamentoSimulacao
      formasPagamentoSimulacao.forEach( (value) => {
        self.formasPagamento.push({html: '<b> Cartão de Crédito - Parcela Express  ' + value.installment  + ' x ' + this.formataReais(value.installment_amount_cents) +'</b> ( Tarifa Bancária - ' + value.cet + '% )', 'value': value.code })
      })
    },
    formataReais(number){
      number = parseFloat((number/100)).toFixed(2);
      return new Intl.NumberFormat('pt-BR', {style: 'currency',currency: 'BRL', minimumFractionDigits: 2}).format(number);
    },
    apenasNumeros(string) 
    {
        var numsStr = string.replace(/[^0-9]/g,'');
        return parseInt(numsStr);
    },

    gerarBoleto(vl_cancelamento, nm_chave, documento, vl_protestado, cd_ibge){
      
      let vl_cancelamento_total = this.calculaValorCancelamento(vl_cancelamento);
      //console.log(dadosTitulo);
      const token = localStorage.getItem("jwtToken");
      // this.$bvModal.show('modal-conf');
      this.boletoSelecionado.token = token;
      this.boletoSelecionado.vl_orcServ = vl_cancelamento;
      this.boletoSelecionado.vl_orcamento = vl_cancelamento;
      this.boletoSelecionado.nm_chave = nm_chave;
      this.boletoSelecionado.cpfCnpj = documento;
      this.boletoSelecionado.vl_protestado = vl_protestado;
      this.boletoSelecionado.cd_ibge = cd_ibge;
      this.boletoSelecionado.consulta = 1;
      this.boletoSelecionado.vl_servico_complementar = this.getValorServicoComplementar(vl_cancelamento);
     

      API.post(`certidao/travas_pedido`, this.boletoSelecionado).then( (res) => {
        if(res.data.situacao)
        {
          this.simulacaoPagamentos(vl_cancelamento)
          this.linkPIX = '';
          this.formaPagamento = 0;
          this.$refs['modalPagamento'].show();
        }
        else 
        {
          this.msgValida = res.data.mensagem
          this.$refs['modalErro'].show();
        }
        
      })
      
      //localStorage.setItem('idPedido');
      //this.bolSel = pedidoid;
    },
    cancProt_instabilidade() {
      this.$refs['modalInstabilidade'].show();
    },
    async cancProt(nm_chave, index, documento, uf, vl_custas, vl_protestado, cd_ibge, nr_cartorio) {
      if (uf != "SP") {
        //enviar o usuario para efetuar o login
        if (!localStorage.getItem("jwtToken")) {
          this.$router.push({ name: "login", params: { tipo_login: "" } });
        }
        
        this.gerarBoleto(vl_custas, nm_chave, documento, vl_protestado, cd_ibge)
        
        // this.$refs["modalLoading"].show();

        const token = localStorage.getItem("jwtToken");
        document.getElementById(nm_chave + index).innerHTML =
          "<div class='alert alert-warning' role='alert' style='text-align:center'>Processando ....<div class='spinner-grow' role='status'><span class='sr-only'></span></div></div>";

        // API.post(`consulta/gerarBoleto?token=${token}`, {
        //   nm_chave: nm_chave,
        //   cpfCnpj: documento,
        //   uf: uf,
        //   vl_custas: vl_custas,
        //   vl_protestado: vl_protestado,
        //   cd_ibge: cd_ibge,
        //   nr_cartorio: nr_cartorio,
        // }).then((res) => {
        //   if (res.data.tempedido) {
        //     this.nm_chave = res.data.nm_chave;
        //     this.linha = index;
        //     this.tempedido = true;
        //     document.getElementById(this.nm_chave + this.linha).style.display = "none";
        //     this.$refs["modalBoleto"].show();
        //   } else {
        //     if (res.data.mensagem == "Comarca Bloqueada") {
        //       this.msg_retorno = res.data.mensagem;
        //       this.$refs["modalBoleto"].show();
        //     }
        //   }
        //   this.$refs["modalLoading"].hide();
        //   this.msg_retorno = res.data.mensagem;
        //   this.ds_endereco_boleto = res.data.ds_endereco_boleto;
        // });
        //        API.get(`consulta/dadosanuencia/${nm_chave}/${token}`).then((res) => {
        //          })
      } //diferente sp
      else {
        window.open("https://protestosp.com.br/Cancelamentos/Simples", "_blank");
      }
    },
    acessaPainel() {
      location.href = "/panel";
    },
    enviarSolicitacao() {
      let self = this;
      self.exibir = false;
      const dados = { ...self.$data };
      const nome = dados.nome_completo,
        documento = self.documento_solicitante,
        rg_solicitante = self.rg_pesquisado,
        nr_cep_pesquisado = self.dadosPesquisado.cep,
        nm_endereco_pesquisado = self.dadosPesquisado.endereco,
        nm_bairro_pesquisado = self.dadosPesquisado.bairro,
        nm_cidade_pesquisado = self.dadosPesquisado.cidade,
        nm_uf_pesquisado = self.dadosPesquisado.uf,
        nm_email_pesquisado = self.dadosPesquisado.email,
        cartorios = dados.cartorios_selecionados,
        endereco = self.solicitante.endereco,
        numero = self.solicitante.numero,
        complemento = self.solicitante.complemento,
        bairro = self.solicitante.bairro,
        municipio = self.solicitante.municipio,
        uf = self.solicitante.uf,
        enviaCepApi = self.enviaCep,
        valor = self.service.valor,
        prazo = self.service.prazo,
        envio = self.showOption,
        motivo_solicitacao = self.motivo_solicitacao;
      const dadosEnviar = {
        nome,
        documento,
        rg_solicitante,
        nr_cep_pesquisado,
        nm_endereco_pesquisado,
        nm_bairro_pesquisado,
        nm_cidade_pesquisado,
        nm_uf_pesquisado,
        nm_email_pesquisado,
        cartorios,
        endereco,
        numero,
        complemento,
        bairro,
        municipio,
        uf,
        enviaCepApi,
        valor,
        prazo,
        envio,
        motivo_solicitacao,
      };
      const token = localStorage.getItem("jwtToken");

      API.post(`certidao?token=${token}`, dadosEnviar).then((res) => {
        let num_pedido_certidao = res.data.inserido;
        if (num_pedido_certidao > 0) this.sucesso(num_pedido_certidao);
        else {
          this.erroCertidao = res.data.descricao;
          this.$refs["erro"].show();
        }
      });
    },
    sucesso(num_pedido_certidao) {
      this.$router.push({ name: "sucesso", params: { numero: num_pedido_certidao } });
    },
    mascaraCep(num) {
      var cep = num.target.value;
      cep = cep.replace(/\D/g, "");
      cep = cep.replace(/^(\d{5})(\d)/, "$1-$2");
      this.service.cep = cep;
    },
    maxLength(num) {
      var campo = num.target.value.length;
      if (campo > 8) {
        num.preventDefault();
        this.service.cep = this.service.cep.substr(0, 9);
      }
    },
    voltar() {
      console.log(this.$route.name);
      if(this.$route.name === 'consulta'){
        if(this.totem) this.$router.push({ name: 'totem' });
        else this.$router.push({ name: 'home' }); 
      }
      if(this.$route.name === 'certidao'){
        this.$router.push({ name: 'consulta', params: { documento: this.documento, totem: this.totem} });
      }
      
    },
    solicitar() {
      if(this.qtdTitulos == 0) this.$router.push({ name: 'certidaoNegativa' });
      else{
        // if(this.cadastroCompleto){ //enviar o usuario para efetuar o login
          // this.$router.push({ name: 'login', params: { tipo_login: '' } })
        if (this.solicitarCertidao) {
          if (this.validar()) this.enviarSolicitacao();
        } else {
          localStorage.setItem("documento", this.documento);
          if (this.logged) this.$router.push({ name: "emolumentos" });
          else this.$router.push({ name: "login", params: { tipo_login: "solicitarCertidao" } });
        }
        // }
        // else this.$refs['erroPush'].show();
      }
    },
    validar() {
      let travaDadosPes = false;

      if (this.nome_completo) this.nome_completo_state = null;
      else {
        this.nome_completo_state = false;
        this.$refs.nome_completo.focus();
      }
      if (this.documento_solicitante) this.validation_documento_solicitante = true;
      else {
        this.validation_documento_solicitante = false;
        this.$refs.documento_solicitante.focus();
      }
      if (this.rg_pesquisado && this.sg_uf == "MS" && this.documento_solicitante.length == 14) {
        this.validation_rg_pesquisado = null;
        travaDadosPes = false;
      } else if (!this.rg_pesquisado && this.sg_uf == "MS" && this.documento_solicitante.length == 14) {
        this.validation_rg_pesquisado = false;
        this.$refs.rg_pesquisado.focus();
        travaDadosPes = true;
      }

      Object.keys(this.dadosPesquisado).forEach((element) => {
        let elementoAtual = this.dadosPesquisado[element].trim();
        let validationErro = "pesquisado_" + element;
        if (elementoAtual.length <= 0 && element != "email") {
          this.validations[validationErro] = false;
          travaDadosPes = true;
        } else this.validations[validationErro] = true;
      });
      this.nome_completo_state = this.nome_completo ? null : false;
      this.calcEnvioState = this.service.cep ? null : false;
      this.numeroState = this.solicitante.numero ? null : false;
      this.bairroState = this.solicitante.bairro ? null : false;
      this.municipioState = this.solicitante.municipio ? null : false;
      this.enderecoState = this.solicitante.endereco ? null : false;
      let camposObrig = false;

      let motivo_solicitacao_sem_espaco = this.motivo_solicitacao.trim();

      if (motivo_solicitacao_sem_espaco == null || motivo_solicitacao_sem_espaco.length < 10) {
        this.motivo_solicitacaoState = false;
        travaDadosPes = true;
      } else this.motivo_solicitacaoState = true;
      if (
        (this.nome_completo_state === null && this.calcEnvioState === null && this.numeroState === null && this.bairroState === null && this.municipioState === null && this.enderecoState === null) ||
        this.showOption === "T" ||
        this.infocert === "D"
      )
        camposObrig = true;
      //if(this.showOption === "T")camposObrig  = false;

      return this.nome_completo && !travaDadosPes && this.cartoriosSelecionados() && camposObrig ? true : false;
      // 00000758834225
    },
    cartoriosSelecionados() {
      this.cartorios_selecionados = [];
      let selecionados = 0;
      let tituloSelecionados = 0;
      for (let UF in this.UFs) {
        for (let index in this.UFs[UF]) {
          const titSel = this.UFs[UF][index].titulos.filter((d) => d.selected === true);
          if (titSel.length > 0) tituloSelecionados++;

          // adiciona cartório à lista
          if (this.UFs[UF][index].selected || titSel.length > 0) {
            let dadosCartorio = {
              cod_cartorio: this.UFs[UF][index].numeroCartorio,
              cod_ibge: this.UFs[UF][index].codIBGE,
              titulos: [this.UFs[UF][index].titulos],
            };
            this.cartorios_selecionados.push(dadosCartorio);
          }
          // incrementa quantidade de cartórios adicionados à lista
          selecionados += this.UFs[UF][index].selected ? 1 : 0;
        }
      }
      this.alert_cartorios = selecionados > 0 || tituloSelecionados > 0 ? false : true;
      return selecionados || tituloSelecionados > 0;
    },
    onVerify: function(response) {
        this.token_captcha = response;
        if(this.consulta_detalhe == false)this.consultar(this.ip_maquina)
        else 
        {
          this.detalheSP(this.item)
          this.consulta_detalhe = false
        }
    },
    consultar(ip_maquina_cliente) {
      let password = process.env.VUE_APP_CHAVE_CRIPTOGRAFIA.toString();
      let self = this;
      var aIDCartorio = {};
      if (this.documento) {
        var tp_resposta = "";
        if (this.solicitarCertidao) tp_resposta = "u";
        else tp_resposta = "t";
        // else tp_resposta = 'u';

        let now = new Date()
          .toISOString()
          .slice(0, 16)
          .toString();
        let encrypted = CryptoJSAesJson.encrypt(now, password);

        let encryptedUrl = btoa(encrypted);

        let Nav = CryptoJSAesJson.encrypt(navigator.userAgent, password);

        let navb64 = btoa(Nav);
        const token = sessionStorage.getItem("jwtToken");

        API.get(`consulta/${this.documento}/${ip_maquina_cliente}/${this.token_captcha}/${token}/${tp_resposta}/${encryptedUrl}/${navb64}`).then((res) => {
        // API.get(`consulta/${this.documento}/${ip_maquina_cliente}/${this.token_captcha}/${btoa(token)}/${tp_resposta}/${encryptedUrl}/${navb64}`).then((res) => {
          if (res.data.situacao == 'erro_codigo') {
            alert(res.data.mensagem)
            this.$router.push({ name: 'home' })
          }
        if (res.data.situacao == 'erro_captcha') {
            alert(res.data.mensagem)
            this.$router.push({ name: 'home' })
          }
          else if (res.data.situacao == 'bloqueio_temporario') {
            alert(res.data.mensagem)
            this.$router.push({ name: 'home' })
          }
          else if (res.data.situacao == 'limite_excedido') {
            alert(res.data.mensagem)
            this.$router.push({ name: 'home' })
          }
          else if (res.data.situacao == false ) {
            alert(res.data.mensagem)
            this.$router.push({ name: 'home' })
            self.exibir = true;
          } else {
            let encrypted = JSON.stringify(res.data);
            let decrypted = JSON.parse(CryptoJSAesJson.decrypt(encrypted, password));
            res.data = decrypted;
            self.tratarCartorios(res.data);
            if(this.qtdTitulos > 0)
            {
              res.data.cartorio.forEach((uf) => {
                uf.dadosCartorio.forEach((item, i) => {
                  let documentosTitulos = Object.keys(item.titulos);
                  documentosTitulos.forEach((documento) => {
                    let titulos = item.titulos[documento];
                    if(titulos !== null && titulos.length > 0)
                    {
                      let totTitulosAnuidos = titulos.filter((d) => d.temAnuencia == "true");
                      if (totTitulosAnuidos !== undefined && totTitulosAnuidos.length > 0) this.titulosAnuido = true;
                    }
                    aIDCartorio[i] = {};
                    aIDCartorio[i]["cod_abrangencia"] = item.codIBGE;
                    aIDCartorio[i]["numero"] = item.numeroCartorio;
                  });
                });
              });
            }
          }
        }).catch((err) => {
           console.log(err)
            alert("Não foi possivel completar a solicitação, reinicie a consulta, limpe o cache e os cookies do seu navegador antes de tentar novamente");
            this.exibir = false;
            this.$router.push({ name: 'home' })
        });;
      }
      else {
        this.$router.push({ name: 'home' })
      }
    },
    imprimirComprovante() {
      let password = process.env.VUE_APP_CHAVE_CRIPTOGRAFIA.toString();
      let self = this;
      if (this.documento) {
        var tp_resposta = "";

        if (this.solicitarCertidao) tp_resposta = "u";
        else tp_resposta = "t";

        const token = localStorage.getItem("jwtToken");
        
        this.isImprimindo = true;

        API.get(`/consulta/gerarComprovante/${this.documento}/${tp_resposta}/${token}`).then((res) => {
          this.isImprimindo = false;
          const linkSource = `data:application/pdf;base64,${res.data.file}`;
          const downloadLink = document.createElement("a");
          const fileName = res.data.fileName;

          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          // let encrypted = JSON.stringify(res.data);

          // let decrypted = JSON.parse(CryptoJSAesJson.decrypt(encrypted, password))
          // res.data = decrypted;
        });
      }
    },
    tratarCartorios(res) {
      var self = this;
      let cartorios = res.cartorio;
      if (res.dataConsulta !== undefined && res.dataConsulta !== null) self.dataConsulta = res.dataConsulta;
      self.qtdTitulos = res.qtdTitulos;
      self.status = res.status;
      self.mensagem = res.mensagem;
      self.servico_complementar = res.servico_complementar;

      if (cartorios)
        cartorios.forEach((item) => {
          item["dadosCartorio"].forEach((cartorio) => {
            // cria estado, se não houver
            if (self.estadosBloqueados[item["uf"]] === true) self.exibeEstados[item["uf"]] = true;

            if (!self.UFs[item["uf"]]) self.UFs[item["uf"]] = [];
            cartorio["_showDetails"] = true;
            // adiciona cartório ao estado
            self.UFs[item["uf"]].push(cartorio);
            //self.UFs._showDetails = true;
            self.total_cartorios++;
            // Mostra notificação caso tenha titulos SP
            if(item["uf"] == 'SP') this.titulosSP = true;
          });
        });

      // exibir resultados!
      self.exibir = true;
    },
    get_flag(uf) {
      return "https://www.cenprotnacional.org.br/imgs/bandeiras/flag-" + uf.toLowerCase() + ".png";
      // return 'http://www.pesquisaprotesto.com.br/static/images/bandeiras/flag-'+uf.toLowerCase()+'.png'
    },
    blockKeys(event) {
      event.preventDefault();
    },
    participantes() {
      this.$router.push({ name: "cartorios" });
    },
    protestosCancelamento() {
      if (this.documento) {
        let self = this;
        API.get(`/pesquisa/tituloanuencia/${self.documento}/${self.token_captcha}`)
          .then((res) => {
            if (res.data.result == 1) {
              self.items = res.data["instrumentoProtesto"];
              setTimeout(() => {
                self.$bvModal.show("modal-anuecia-cancelamento");
              }, 0);
            } else {
              self.msgValida = "Erro ao processar pedido";
              self.$refs["modalErro"].show();
            }
          })
          .catch(() => {
            alert("Não foi possivel completar a solicitação");
            this.exibir = false;
          });
      }
    },
    ver_detalhes(item, uf) {
      this.detalhes_cartorio = item;
      this.detalheUF = uf;
      this.showModal();
    },
    showModal() {
      this.$refs["modal-detalhes"].show();
    },
    ficaOito(evt) {
      var self = this;
      setTimeout(function() {
        self.service.cep = evt.target.value.substr(0, 9);
      }, 0);
    },
    checkCep(event) {
      let len = event.target.value.length;
      if (len === 8) this.calcular_frete();
    },
    async calcular_frete() {
      this.enviaCep = this.service.cep.replace("-", "");

      this.showLoad = true;
      var self = this;
      try {
        const token = localStorage.getItem("jwtToken");
        if (self.aCepOrigem.length == 0) self.nameLoad = false;
        else {
          const res = await API.post(`service/calcFrete/?token=${token}`, { origem: this.aCepOrigem, destino: this.enviaCep });
          this.service.valor = res.data.Valor;
          this.service.prazo = res.data.Prazo;

          axios
            .get(`https://viacep.com.br/ws/${this.enviaCep}/json/`)
            .then((resp) => {
              if (resp.data.erro == true) {
                this.message = "Cep não encontrado.";

                this.erroCep = true;
              } else {
                this.erroCep = false;
                self.solicitante.endereco = resp.data.logradouro;
                self.solicitante.complemento = resp.data.complemento;
                self.solicitante.bairro = resp.data.bairro;
                self.solicitante.municipio = resp.data.localidade;
                self.solicitante.uf = resp.data.uf;
              }
            })
            .catch(() => {
              this.data = null;
            });
        }
      } catch (error) {
        console.error(error);
      } finally {
        if (self.aCepOrigem.length == 0) this.nameLoad = false;
        else this.nameLoad = true;
        this.showLoad = false;
      }
    },
    async adicionaCep(item) {
      let aIDCartorio = [{ cod_abrangencia: item.codIBGE, numero: item.numeroCartorio }];
      let self = this;
      await API.post("/service/cepCartorios", { aIDCartorio }).then((resCep) => {
        if (item.selected) self.aCepOrigem.push(resCep.data[0]);
        else {
          let index = self.aCepOrigem.indexOf(resCep.data[0]);
          self.aCepOrigem.splice(index, 1);
        }
      });
    },
    selectAllRows(item, cidade) {
      let referencia = cidade + item.numeroCartorio;
      this.$refs[referencia][0].items.forEach((element, index) => {
        let statusLinha = item.selected === undefined ? true : item.selected;
        this.$set(this.$refs[referencia][0].items[index], "selected", statusLinha);
      });
    },
    selectClickedRow(item) {
      let referencia = item.cidade + item.numeroCartorio;
      this.$refs[referencia][0].items.forEach((element, index) => {
        let statusLinha = item.selected === undefined ? true : !item.selected;
        this.$set(this.$refs[referencia][0].items[index], "selected", statusLinha);
      });
    },
    BuscarCep: function(cep) {
      var cepl = cep.replace("-", "");
      try {
        axios
          .get(`https://viacep.com.br/ws/${cepl}/json/`)
          .then((resp) => {
            if (resp.data.erro == true) {
              this.message = "Cep não encontrado.";
            } else {
              this.dadosPesquisado.cep = cepl;
              this.dadosPesquisado.endereco = resp.data.logradouro + " " + resp.data.complemento.substr(0, 60);
              this.dadosPesquisado.bairro = resp.data.bairro.substr(0, 45);
              this.dadosPesquisado.cidade = resp.data.localidade.substr(0, 45);
              this.dadosPesquisado.uf = resp.data.uf;
              this.sg_uf = resp.data.uf;
            }
          })
          .catch(() => {
            console.error("error");
          });
      } catch (error) {
        console.error("error");
      }
    },
    cep: function(event) {
      var d = event;
      if (d != null) {
        d = d.replace(/\D/g, "");
        d = d.replace(/^(\d{5})(\d)/, "$1-$2");
        return d;
      }
    },
    detalheSP(item) {
      let self = this;
      let tpDoc = this.documento.length > 11 ? 2 : 1;
      const token = localStorage.getItem("jwtToken");
      API.post(`consulta/detalheSP`, {
        captcha: this.token_captcha,
        tpDoc: tpDoc,
        docDev: this.documento,
        codMun: item.codIBGE,
        nrCart: item.numeroCartorio,
        token: token
      }).then((res) => {
        let indexArray = self.UFs["SP"].findIndex((v) => v.codIBGE == item.codIBGE && v.numeroCartorio == item.numeroCartorio);

        self.UFs["SP"][indexArray].titulos = res.data.cartorio[0].dadosCartorio[0].titulos;
        self.ver_detalhes(item, "SP");
      });
    },
    gerarTokenRecaptcha(item) {
      this.$refs.invisibleRecaptcha.execute();
      this.item = item;
      this.resetRecaptcha();
    },
    respConfirm(resp) {
      if (resp == "s" && this.formaPagamento != 0) {
        const token = localStorage.getItem("jwtToken");
        const dadosParaEnvio = { filtro: this.boletoSelecionado, formaPagamento: this.formaPagamento };
        this.$refs["modalLoading"].show();

        API.post(`certidao/gerarBoleto`, { token: token, dados: dadosParaEnvio })
          .then((res) => {
            if (res.data.situacao == 1) {
              // this.get_certidoes();

              if (this.formaPagamento == 2) {
                // console.log('download_boleto_' + this.boletoSelecionado.cd_pedido)
                this.$refs["modalLoading"].hide();
                let dwnldAnexo = document.getElementById("download_boleto");
                dwnldAnexo.href = res.data.urlBoleto;
                //setTimeout(function(){
                dwnldAnexo.click();
                this.$refs["modalPagamento"].hide();
              } else if (this.formaPagamento == 3) {
                // console.log('download_boleto_' + this.boletoSelecionado.cd_pedido)
                this.linkPIX = res.data.urlBoleto;
                var Quickchart = 'https://quickchart.io/qr?size=300&text=';
                this.pdf = Quickchart + encodeURI(res.data.ds_endereco_boleto);
                // GoogleCharts QR Code - DEPRECATED
                // var GoogleCharts = "https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl=";
                // this.pdf = GoogleCharts + this.linkPIX;

                this.sizemodalboleto = "lg";
                this.startCountDown(30);
                let countInterval2 = setInterval(() => {
                  this.startCountDown(30);
                  this.verificaPagamento(res.data.idBoleto);
                }, 30000);
                this.$root.$on("bv::modal::hidden", (bvEvent, modalId) => {
                  if (modalId == "modalboleto" && bvEvent.type == "hidden") clearInterval(countInterval2);
                });

                this.$refs["modalLoading"].hide();
                this.$refs["modalPagamento"].hide();
                this.$refs["modalBoleto"].show();
              }
            } else {
              this.mensagemBolErro = res.data.mensagem;
              this.$refs["modalLoading"].hide();
              this.$refs["modalBoleto"].show();
            }
            //let resJson = JSON.parse(res.data['enviada']);
            //console.log(resJson);
          })
          .catch((erro) => {
            console.log("post não enviado", erro);
          });
      } else if (resp == "n") {
        this.$refs["modalPagamento"].hide();
      }else if (this.formaPagamento == 0) {
        alert('por favor, selecione uma forma de pagamento')
      }
    },
    startCountDown(duration) {
      let secondsRemaining = duration,
        sec = 0,
        countInterval = setInterval(() => {
          sec = parseInt(secondsRemaining % 60);
          this.secondcd = sec;
          secondsRemaining = secondsRemaining - 1;
          if (secondsRemaining < 0) clearInterval(countInterval);
        }, 1000);
    },
    copiarLink() {
      var copyTextarea = this.$refs.copiar;

      copyTextarea.select();

      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "Texto copiado!" : "Texto não copiado !";
        alert(msg);
      } catch (err) {
        alert("Opa, Não conseguimos copiar o texto, é possivel que o seu navegador não tenha suporte, tente usar Crtl+C.");
      }
    },
    confirmaErroPush(){
      this.$router.push(this.erroPushRoute);
      this.$refs['erroPush'].hide();
    },
    blockForm(){
      const form = document.getElementById('resultados');
      if (form) {
        const elementsToDisable = form.querySelectorAll('input, select, textarea, button, a');
        elementsToDisable.forEach(element => {element.disabled = true;});
      }
    },
    // isCadastroCompleto(){
    //   const token = localStorage.getItem("jwtToken");

    //   API.get(`usuario/dadosbancarios?token=${token}`).then((dadosBancarios) => {
    //     //  if (!res.data[0].nm_nr_cep || !res.data[0].nm_nr_telefone) { -- Nessa condição, nm_nr_cep E nm_nr_telefone são obrigatorios
    //     if (!res.data[0].nm_nr_cep && !res.data[0].nm_nr_telefone) { // Nessa condição, somente um dos valores é obrigatorio
    //       this.blockForm();
    //       this.loading = false;
    //       this.erro = 'Cadastro do usuário incompleto. Para realizar esse procedimento é preciso fornecer mais informações.'
    //       this.errorPush = {name: 'cadastroUser'}
    //       // this.errorPush = {name: 'cadastroUser', params: {dadosLiq: 'liquidacao', dadosBancarios:0}}
    //       this.$refs['erro'].show();
    //     }
    //     else {
    //       this.cadastroCompleto = true
    //       return true;
    //     }
    //   });
    // },
    // Funcao para calcular valor de cancelamento usando servico complementar
    calculaValorCancelamento(vl_custas) {
      let valorCancelamento = parseFloat(vl_custas);

      let valorServico = this.getValorServicoComplementar(vl_custas);

      if (valorServico === 0 || valorCancelamento === 0) return valorCancelamento;
      return Math.round((valorCancelamento + valorServico) * 100) / 100;
    },
    getValorServicoComplementar(vl_custas) {
      let valorCancelamento = parseFloat(vl_custas);

      let servico = this.servico_complementar;
      if (!servico) return 0;

      let valorServico = parseFloat(servico.vl_servico) || 0;
      if (valorServico === 0) return 0;
      
      if (servico.ic_percentual) {
        let percentual = (valorCancelamento * valorServico) / 100;
        return Math.round(percentual * 100) / 100;
      } else {
        return Math.round(valorServico * 100) / 100;
      }
    }


  },
  mounted() {
    this.$root
      .isLogged()
      .then(() => {
        this.logged = true;
      })
      .catch(() => {
        this.logged = false;
      });
    this.getPermicaoServico();
    this.documentoPesquisado = localStorage.getItem("usrCpf");
    // this.$router.push({ name: 'home' });
    this.nomePesquisado = localStorage.getItem("usrName");
    let ip_maquina_cliente = null
    const token = localStorage.getItem('jwtToken')
    // this.isCadastroCompleto()
    let self = this

    // API.get(`usuario/logado?token=${token}`).then( (res) =>  {
            // setTimeout(() => {
              
              // self.nome_completo = res.data[0].nm_usuario
              // self.documento_solicitante = res.data[0].nm_nr_cpfcnpj
              // self.rg_pesquisado = res.data[0].nm_rg
              // self.dadosPesquisado.email = res.data[0].nm_email
              // self.pesquisado_cep = res.data[0].nm_nr_cep.substring(0, 5) + '-' + res.data[0].nm_nr_cep.substring(5, 9)
              
            // },10);
          // })
      this.ip_maquina = '0_0_0_0'
    // axios.get(`https://api.ipify.org?format=json`).then( (res) => {
    //   this.ip_maquina =    res.data.ip.replaceAll('.','_');
    //   ip_maquina_cliente = res.data.ip.replaceAll('.','_');
      this.$refs.invisibleRecaptcha.reset();
      this.$refs.invisibleRecaptcha.execute();
      // console.log(this.$route)
      // if(this.$route.params.token_captcha != undefined && this.$route.params.token_captcha != null)
      // {
      //   this.token_captcha = this.$route.params.token_captcha
      //   this.consultar(ip_maquina_cliente)
      // }
      // else{
      //   this.$refs.invisibleRecaptcha.reset();
      //   this.$refs.invisibleRecaptcha.execute();
      // }
      // setTimeout(() => {this.consultar(ip_maquina_cliente)},1)
    // })
  },
  filters: {
    fone: function (value){
      if (value != undefined) {
        var d = ''
        if(value.length > 10){
          d = value
          d = d.replace(/\D/g, "")
          d = d.replace(/^(\d\d)(\d)/g, "($1) $2")
          d = d.replace(/(\d{5})(\d)/, "$1-$2")
          return d
        }else{
          d = value
          d = d.replace(/\D/g, "")
          d = d.replace(/^(\d\d)(\d)/g, "($1) $2")
          d = d.replace(/(\d{4})(\d)/, "$1-$2")
          return d
        }
      }
    },
    documento: function (value) {
      if (value == null) return '';
      else {
        let v = value;
        //Remove tudo o que não é dígito
        v = v.replace(/\D/g, "");
        if (v.length < 14) { //CPF
          //Coloca um ponto entre o terceiro e o quarto dígitos
          v = v.replace(/(\d{3})(\d)/, "$1.$2");
          //Coloca um ponto entre o terceiro e o quarto dígitos
          //de novo (para o segundo bloco de números)
          v = v.replace(/(\d{3})(\d)/, "$1.$2");
          //Coloca um hífen entre o terceiro e o quarto dígitos
          v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
        } else { //CNPJ
          //Coloca ponto entre o segundo e o terceiro dígitos
          v = v.replace(/^(\d{2})(\d)/, "$1.$2");
          //Coloca ponto entre o quinto e o sexto dígitos
          v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
          //Coloca uma barra entre o oitavo e o nono dígitos
          v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
          //Coloca um hífen depois do bloco de quatro dígitos
          v = v.replace(/(\d{4})(\d)/, "$1-$2");
        }
        return v;
      }
    },
  },
  watch: {
    selecionar_todos(val) {
      for(let UF in this.UFs)
          for(let index in this.UFs[UF])
          {
            this.UFs[UF][index].selected = val
           this.selectAllRows(this.UFs[UF][index], this.UFs[UF][index].cidade)
          }
            
    },
    exibir(val) {
      // foco no campo nome
      if(val && this.solicitarCertidao)
        setTimeout(() => { document.getElementById('nome_completo').focus() }, 500)
    },
    pesquisado_cep: function(val)
    {
      if(val.length == 9)
      {
        this.BuscarCep(val)
        this.dadosPesquisado.cep = val;
        this.validations.pesquisado_cep = true
      }
      else this.validations.pesquisado_cep = false
    },
    documento_solicitante: function(val){
      this.validarDocumento(val)
      if(this.sg_uf == "MS" && this.documento_solicitante.length == 14)
      {
        this.exibeRG = true
        setTimeout(()=> {this.$refs.rg_pesquisado.focus()},1)
      }
      else this.exibeRG = false
    },
    sg_uf: function(val){
      if(val == "MS" && this.documento_solicitante.length == 14)
      {
        this.exibeRG = true
        setTimeout(()=> {this.$refs.rg_pesquisado.focus()},1)
      }
      else this.exibeRG = false
      this.dadosPesquisado.uf = val
    },
    exibeRG: function(val){
      this.rg_pesquisado =  !val ? null : this.rg_pesquisado
    }
  }
}
</script>

<style scoped>
.barra-consulta{  
  display: flex;
  width: 100%;
  background: white;
  justify-content: center;
  position: fixed;
  bottom: 37px;
  z-index: 100;
  padding: 16px 0;
  box-shadow: 4px -2px 20px -3px #00000065;
}
.row-botoes-consulta{
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
  max-width: 964px;
}
.row-botoes-consulta .float-right{
  margin:0;
  margin-left:auto;
  display:flex;
  align-items:center;
  gap: 15px;
}
.row-botoes-consulta span{
  font: normal normal normal 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #707070;
}
.barra-consulta .btn-solicitar-certidao{
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  text-align: center;
  font: normal normal bold 18px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #ffffff;
  padding: 0;
  background: #4780F1 0% 0% no-repeat padding-box !important;
  border: 3px solid #4780F1 !important;
  border-radius: 5px;
  padding: 0 14px;
}
.barra-consulta .btn-solicitar-certidao:hover{
  color: #4780F1 !important;
  background: #ffffff 0% 0% no-repeat padding-box !important;
}
.barra-consulta .btn-solicitar-certidao.finalizar-solicitacao{
  background: #1ACEB5 0% 0% no-repeat padding-box !important;
  border: 3px solid #1ACEB5 !important;
}
.barra-consulta .btn-solicitar-certidao.finalizar-solicitacao:hover{
  color: #1ACEB5 !important;
  background: #ffffff 0% 0% no-repeat padding-box !important;
}
.printing-loader{width: 40px; height: 20px;display:flex;align-items:center;margin:0px 4px;}
.text-loader {position:absolute; width: 10px; height: 10px; margin-top:3px; background-color:#597EB5; animation: loaderAnimation 3s infinite;border-radius:100%;}
.bg-1ACEB5 {background-color:#1ACEB5;}
.bg-209CEE {background-color:#209CEE;}
.bg-4780F1 {background-color:#4780F1;}
.text-loader:nth-child(1) {animation-delay: 0s;}
.text-loader:nth-child(2) {animation-delay: 0.2s;}
.text-loader:nth-child(3) {animation-delay: 0.4s;}
@keyframes loaderAnimation {
  0%, 10%, 90%, 100%{ transform: translateX(0); }
  40%, 60%{ transform: translateX(30px); }
}

.texto-Imprimir:before{
  content:'Imprimir';
  
}
.printing-animation:before {
  animation: printingAnimation 35s infinite;
}

@keyframes printingAnimation {
  0%, 1%, 19%, 21%, 39%, 41%, 59%, 61%, 79%, 81%, 99%, 100%{ opacity: 0; }
  2%, 18%, 22%, 38%, 42%, 57%, 63%, 77%, 83%, 97% { opacity: 1; }
  
  0%, 19% { content: "Imprimindo"; }
  20%, 39% { content: "Por favor, Aguarde"; }
  40%, 100% { content: "Esta ação pode levar algum tempo"; }
}

#resultados
#resultados .table{margin-bottom: 0;}
#resultados button.btn-outline-secondary {height:41px;display:flex;align-items:center;justify-content:center;border:none;padding: 0;font: normal normal bold 15px/20px 'Kanit', sans-serif; letter-spacing: 0px;color: #597EB5;}
#resultados .btn-outline-secondary img{width: 21px;height: 21px;margin-left: 6px;}
#resultados button.btn-outline-secondary:active,
#resultados button.btn-outline-secondary:hover {background-color: unset;outline: none;border: none;-webkit-box-shadow: none;box-shadow: none;}
#resultados p {
  font: normal normal normal 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #707070;
  margin-bottom: 20px;
}
#resultados h4 {
  font: normal normal bold 25px/30px 'Kanit', sans-serif;
  letter-spacing: 0px;
  margin-bottom: 20px;
}
#resultados a {
  font: normal normal normal 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #597EB5 !important;
}
#resultados a:hover,
#resultados a:visited {
  color: #597EB5 !important;
  opacity: 1;
}
#resultados .textoInformativo{
  font: normal normal normal 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;

}
#resultados .row{
  margin: 0px ;
}
#resultados .alert.alert-warning,
#resultados .alert.alert-danger,
.alerta-anuencia.alert.alert-warning{
  max-height: 49px;
  padding: 15px 17px;
  border-radius: 5px;
  font: normal normal bold 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  text-align:start !important;
}
#resultados .alert.alert-warning,
.alerta-anuencia.alert.alert-warning {
  background: #F8F5CB 0% 0% no-repeat padding-box;
  color: #706927;
}
#resultados .alert.alert-danger{
  background: #F8CBCB 0% 0% no-repeat padding-box;
  color: #702727;
}
#resultados .alert.alert-danger a{
  color: #702727 !important;
  font: normal normal bold 15px/20px 'Kanit', sans-serif !important;
  text-decoration: none;
}
#resultados .btn-outline-primary:hover{
  background: #4780F1;
  color: white;
}
.titulo-anuencia-container > p{
  font: normal normal normal 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  padding-left:12px;
}
.text-consulta-modal,
.detalhes-cartorio-container p {
  font: normal normal normal 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color:#000;
  margin-bottom: 0;
}

.alerta-anuencia.alert.alert-warning{max-height: 50px;}
.titulo-anuencia-container button{
  
  width: 167px;
  height: 49px;
  background: #F2F6FE 0% 0% no-repeat padding-box;
  border: 3px solid #4780F1;
  border-radius: 5px;
  color: #4780F1;
  text-align: center;
  font: normal normal bold 15px/30px 'Kanit', sans-serif;
  letter-spacing: 0px;
}
.titulo-anuencia-container button:active,
.titulo-anuencia-container button:focus,
.titulo-anuencia-container button:hover{
  outline: none !important;
  box-shadow: none !important;
  background-color: #4780F1 !important;
  border-color: #4780F1 !important;
  color: white;
}
.titulo-anuencia-container button svg{width: 18px;height: 18px;margin-right: 7px;}
#resultados .btn-outline-primary{
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 3px solid #4780F1;
  border-radius: 5px;
  text-align: center;
  font: normal normal normal 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #4780F1;
  cursor: pointer;
  width: 85px;
  min-width: 85px;
  height: 34px;
  user-select: none;
}
#resultados .container{
  padding: 0 ;
}
#wrapper-spinner {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: calc(100% - 80px);
}
#wrapper-spinner .v-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -10px 0px 0px -20px;
}

#resultados {
  overflow-y: auto;
  /* position: fixed; */
  width: 100%;
  left: 0px;
  top: 80px;
  height: fit-content;
  /* background-color: var(--main-bg-cinza); */
  overflow-x: hidden;
  margin: 0 auto;
  margin-top: 120px;
  display: flex;
  flex-flow: column;
  min-height: calc(100vh - 40px - 80px);
  justify-content: space-between;
  margin-bottom: 37px;

}
#resultados.certidao {
  top: 0px;
  height: calc(100% - 80px);
}
#wrapper-estados {
  padding: 60px 0px 120px;
  /* position: relative; */
  /* left: 50%; */
  /* margin-left: -500px; */
  /* width: 1000px; */
  display: flex;
  flex-flow: column;
  width: 964px;
  margin: 0 auto;
}

figure.flag img {
  width: 56px;
  box-shadow: 3px 3px 10px 0px rgba(110,130,208,0.3);
}

figure.flag.flag-notificacao img {
  width: 34px;
  margin-top: -5px;
  margin-right: 10px;
}

.segment {
  margin-bottom: 20px;
  padding: 0px;
  background-color: #FFF;
  border-radius: 8px;
  box-shadow: none;
}
.segment header {
  overflow-y: auto;
  padding: 0px 15px;
  border-bottom: 1px solid rgba(0,0,0,0.1);
}

.input-documento {
  width: fit-content;
  padding: 0px;
  margin-left: 5px;
  background:none;
  border: none;
  font: normal normal normal 15px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  box-shadow:none !important;
}

#barra-footer {
  /* position: fixed; */
  /* left: 0px; */
  /* bottom: 37px; */
  width: 100%;
  height: 80px;
  background-color: #FFF;
}
 #loading-solicitante {
        vertical-align: 0;
        margin-left: -21px;
    }
    .load{
        top: 60%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;

position: relative;
    }
    .spin {
        background: #fff;
        height: 80px;
        width: 80px;
        border-radius: 50vh;
        border-color: #004E86;
        border-top: 5px solid  #004E86;
        animation: loading 3s linear infinite;
    }
    .loading{
        position: absolute;
        color: #000;
    } @keyframes loading{
        100%{
            transform: rotate(360deg)
        }
    }
  
  
.blueResult{
    /* margin-left:320px !important; */
    /* color:#209CEE; */
  text-align: left;
  font: normal normal bold 30px/41px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #597EB5;
  
  padding: 0 !important;
    margin: 0;
}
.blue {font: normal normal bold 25px/30px 'Kanit', sans-serif;}

@media (min-width: 360px) and (max-width: 765px) {
.blue {
margin-left: 0%;
}
.blueResult{
/* margin-left: 331px;
color: #209CEE; */
text-align: left;
font: normal normal bold 30px/41px 'Kanit', sans-serif;
letter-spacing: 0px;
color: #597EB5;

padding: 0 !important;
    margin: 0;

}
.container{
  margin-left: 323px;
}
.card{
/* margin-left: 331px;
margin-right: 331px; */
}
.mt-3, .my-3 {
    margin-top: 0rem !important;
}
.btn-lg, .btn-group-lg > .btn {
    font-size: 1rem;
}
.cardCel{
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 337px;
  background-color: none;
}
.doc{
  margin-left: 357px;
}
.Data{
  margin-left: 343px;
}
.DataConsta{
margin-left: -291px;
}
.table th, .table td {
    display: block !important;
}
.table thead th {
      display: block !important;
}
.blueResult{
  /* margin-left:320px !important; */
  /* color:#209CEE; */
text-align: left;
font: normal normal bold 30px/41px 'Kanit', sans-serif;
letter-spacing: 0px;
color: #597EB5;

padding: 0 !important;
    margin: 0;

}
.segment{
    margin-left: 331px;
    margin-right: 331px;
}
.blueSolicita{
  margin-left: 333px;
  color: #209CEE;
}
/* .alert{
  margin-left: 332px;
  margin-right: 332px;
} */
}
.btn-fixed-right{
  position: absolute;
  right: 5vw;
}
#resultados #barra-footer .row button{width:fit-content;}
@media (max-width:1199px) {
  #resultados{
    margin-top: 68px;
    margin-bottom: 0px;
    padding-top: 0px;
  }
  #wrapper-estados{width: calc(100% - 34px);padding-top: 20px;}
  .cardCel{padding:0;margin:0 auto;}
  .container{margin-left: 0;}
  #resultados .textoInformativo{margin-bottom: 20px;}
  #resultados .alert.alert-warning,
  #resultados .alert.alert-danger,
  .alerta-anuencia.alert.alert-warning{font: normal normal bold 14px/18px 'Kanit', sans-serif;height: fit-content;}
  .segment{margin:0;}
  #resultados .table {overflow-y: overlay;display: block;}
  
  #resultados .table::-webkit-scrollbar{width: 17px;}
  #resultados .table::-webkit-scrollbar-track{background:transparent;}
  #resultados .table::-webkit-scrollbar-thumb{background-color: #707070;border-left: 18px solid transparent;border-right: 18px solid transparent;background-clip: padding-box;border-radius: 27200px;border-bottom: 8px solid transparent;border-top: 8px solid transparent;}

  #wrapper-spinner {position: relative;left: 0px;top: 68px;width: 100vw;height: calc(100vh - 377px - 68px);margin-bottom: 68px;}
  .blueSolicita{margin-left: 0;}

  #resultados #barra-footer .row{
    margin: 0px;
    display: flex;
    align-items: center;
    height: 100%;
  }
  #resultados #barra-footer .row > *{
    width: fit-content;
    margin: 0 !important;
    padding: 0;
  }
  #resultados #barra-footer .row > *:nth-child(2){
    position: relative;
    right: 21px;
  }
  #resultados #barra-footer .row > *:nth-child(2) .btn{
    /* width: 145px; */
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    font-size: 1rem;
    margin: 0 !important;
  }
  #resultados #barra-footer .row > *:last-child .btn{
    margin: 0;
    width: fit-content;
  }
  .doc, .Data{
    margin:0px;
    padding:0px;
    margin-bottom: 10px;
  }
  #resultados #barra-footer .row button{font-size:1rem;}
}
</style>
